export const xs = 0
export const md = 768
export const lg = 1200
export const xl = 1600
export const lgMenu = 1220
